import React from 'react';
import { useDispatch } from 'react-redux';
import { formatBookingDuration } from '../../../core/utils/date';
import Booking from '../../../core/types/model/Booking';
import { Actions as BookingActions } from '../../../core/state/bookings/actions';
import { BookingStatus } from '../../../core/enums/BookingStatus';
import deliveryZoneColorMap from '../../../core/constants/deliveryZoneColorMap';
import DeliveryZoneBadge from '../../components/delivery-zone-badge/DeliveryZoneBadge';
import BookingStatusBadge from '../../components/booking-status-badge/BookingStatusBadge';
import TR from '../../../components/table/TR/TR';
import TD from '../../../components/table/TD/TD';

interface Props {
  booking: Booking;
}

const BookingListRowMobileScreen: React.FC<Props> = ({ booking }) => {
  const dispatch = useDispatch();

  const openBooking = (bookingItem: any) => dispatch(BookingActions.openDetails(bookingItem));

  return (
    <TR
      key={booking.id}
      onClick={() => openBooking(booking)}
      className={`booking-row ${booking.confirmationStatus === BookingStatus.Pending ? 'booking-row--pending' : ''}`}
    >
      <TD className={`booking-row__bordered booking-row__bordered--${deliveryZoneColorMap[booking.deliveryZoneId]} booking-row--mobile`}>
        <span className="booking-row__title text-truncate">{booking.title}</span>
        <div className="d-flex justify-content-between">
          <span className="text-nowrap">{formatBookingDuration(booking)}</span>
          <DeliveryZoneBadge id={booking.deliveryZoneId} />
          <BookingStatusBadge
            rejectionReason={booking.confirmationStatus === BookingStatus.Canceled ? booking.cancellationReason : booking.rejectionReason}
            status={booking.confirmationStatus}
          />
        </div>
      </TD>
    </TR>
  );
};

export default BookingListRowMobileScreen;
